import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Science from "./pages/Science";
import Business from "./pages/Business";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import AuthVerify from "./pages/AuthVerify";
import AuthCallback from "./pages/AuthCallback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import { ScrollToTop } from "./components/ScrollToTop";
import { MobileStickyCTA } from "./components/layout/MobileStickyCTA";
import { Toaster } from "sonner";

function App() {
    return (
        <MotionConfig reducedMotion="user">
            <LanguageProvider>
                <AuthProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/science" element={<Science />} />
                            <Route path="/business" element={<Business />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogArticle />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/faq" element={<FAQ />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/confirmation" element={<OrderConfirmation />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/auth/verify" element={<AuthVerify />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route path="/privacy" element={<PrivacyPolicy />} />
                            <Route path="/terms" element={<TermsConditions />} />
                        </Routes>
                        <MobileStickyCTA />
                        <Toaster position="top-center" richColors closeButton />
                    </BrowserRouter>
                </AuthProvider>
            </LanguageProvider>
        </MotionConfig>
    );
}

export default App;
